import { useState } from "react";
import type { BingoChoice, BingoPublicState } from "@hitster/shared";

interface Props {
  bingo: BingoPublicState;
  disabled: boolean;
  onSubmit: (answer: string | number) => void;
}

export function BingoAnswerPanel({ bingo, disabled, onSubmit }: Props) {
  const cat = bingo.category;
  const [year, setYear] = useState("");
  const [text, setText] = useState("");

  if (!cat) return null;

  if (bingo.mySubmitted) {
    return (
      <div className="cw-panel p-5 text-center space-y-2">
        <p className="text-green-400 font-semibold text-lg">✅ Réponse enregistrée</p>
        {bingo.myAnswerLabel && (
          <p className="text-violet-200/80">Vous avez répondu : {bingo.myAnswerLabel}</p>
        )}
        <p className="text-sm text-violet-400">
          {bingo.answeredCount} / {bingo.answeringTotal} joueurs ont répondu
        </p>
      </div>
    );
  }

  if (cat.answerType === "CHOICE" || cat.answerType === "MULTIPLE_CHOICE") {
    const choices: BingoChoice[] = cat.choices ?? [];
    const big = choices.length <= 2;
    return (
      <div className="space-y-3">
        <p className="text-center text-lg font-semibold">{cat.description}</p>
        <div className={`grid gap-3 ${big ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-2"}`}>
          {choices.map((choice) => (
            <button
              key={choice.id}
              type="button"
              disabled={disabled}
              className={`cw-btn cw-btn-primary ${big ? "min-h-16 text-xl" : "min-h-14 text-base"}`}
              onClick={() => onSubmit(choice.id)}
            >
              {choice.label}
            </button>
          ))}
        </div>
      </div>
    );
  }

  if (cat.answerType === "YEAR") {
    return (
      <form
        className="space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          const n = Number(year);
          if (!Number.isInteger(n)) return;
          onSubmit(n);
        }}
      >
        <p className="text-center text-lg font-semibold">{cat.description}</p>
        <input
          type="number"
          inputMode="numeric"
          className="cw-input text-center text-3xl font-bold tracking-wide"
          placeholder="Année"
          min={1900}
          max={2100}
          value={year}
          disabled={disabled}
          onChange={(e) => setYear(e.target.value)}
          aria-label="Année"
        />
        <button type="submit" className="cw-btn cw-btn-primary w-full min-h-14 text-lg" disabled={disabled || !year}>
          Valider
        </button>
      </form>
    );
  }

  return (
    <form
      className="space-y-3"
      onSubmit={(e) => {
        e.preventDefault();
        if (!text.trim()) return;
        onSubmit(text.trim());
      }}
    >
      <p className="text-center text-lg font-semibold">{cat.description}</p>
      <input
        type="text"
        className="cw-input text-lg"
        placeholder="Votre réponse"
        autoComplete="off"
        autoCorrect="off"
        value={text}
        disabled={disabled}
        onChange={(e) => setText(e.target.value)}
        aria-label="Réponse"
      />
      <button type="submit" className="cw-btn cw-btn-primary w-full min-h-14 text-lg" disabled={disabled || !text.trim()}>
        Valider
      </button>
    </form>
  );
}
